import { useIntl } from 'react-intl'

import BadgeCinestar from '../../../../../../components/Badges/BadgeCinestar/BadgeCinestar'
import Icon from '../../../../../../components/Icon/Icon'
import SkeletonLoader from '../../../../../../components/SkeletonLoader/SkeletonLoader'
import Typography from '../../../../../../components/Typography/Typography'

import BadgeMovie from 'components/Badges/BadgeMovie/BadgeMovie'
import './MovieDetails.scss'

const MovieDetails = ({ movie }) => {
    const intl = useIntl()

    const genresArr = movie?.genres?.split(', ')

    return (
        <div className={'movie-details h-100 d-flex flex-column justify-content-center'}>
            <Typography variant={'hero'} className={'mb-2'}>
                {movie?.title_group ?? movie?.title ?? <SkeletonLoader />}
            </Typography>

            <div className={'movie-details--badges d-flex'}>
                {movie?.event_properties?.map((property, idx) => (
                    <BadgeMovie key={idx} badge={property} />
                ))}
            </div>

            <div className={'movie-details--badges d-flex'}>
                {movie?.duration_minutes ? (
                    <BadgeCinestar type={'outline'}>{`${movie?.duration_minutes ?? 0} MIN`}</BadgeCinestar>
                ) : (
                    <SkeletonLoader />
                )}
                {movie?.title_properties?.map((genre) => (
                    <BadgeCinestar key={`badge-${''}`} type={'filled'} className={'my-auto'}>
                        {genre?.name}
                    </BadgeCinestar>
                ))}
                {movie?.movieSubtitles && (
                    <div className={'d-flex align-items-center gap-1'}>
                        <Icon name={'subtitles'} />
                        <Typography variant={'desc'}>
                            {intl.formatMessage({ id: `hall.hallHeader.subtitles` })}
                        </Typography>
                    </div>
                )}
            </div>

            {/* <BadgeCinestar type={'filled'} className={'me-auto'}>
                DIGITALNI PROJEKTORY
            </BadgeCinestar> */}
        </div>
    )
}

export default MovieDetails
